import * as React from 'react';

const Page404: React.StatelessComponent = () => (
  <section>
    <div className="container">
      <div className="row">
        <div className="col-md-8">
          <h1 className="bold-title f-w-100 primary-font">Página no encontrada error 404</h1>
          <div className="gap-20"/>
        </div>
        <div className="col-md-4">
          <p className="breadcrumb text-right">Inicio > Error 404</p>
        </div>
      </div>
    </div>
  </section>
);

export default Page404;


// WEBPACK FOOTER //
// ./src/modules/404/Page404.tsx